import React, {useCallback, useContext} from 'react';
import Slider from "antd/lib/slider";
import {FormContext} from "../metadata/MDForm";
import {dateToString, today} from "../../utils/dateUtils";

export function DriverMinAge({min, max, birthDtAttr, onChange, value, ...props}) {

  // const val = minAge === -1 ? min : minAge;

  let {setValueByAttr} = useContext(FormContext);

  const onSliderChange = v => {
    onChange(v);
    setValueByAttr(birthDtAttr, dateToString( today().subtract(v, 'years') ) );
  };

  value = Math.max(parseInt(value || 0), min);

  return <div>
    Driver minimum age: <b>{value}</b>
    <Slider
      min={min}
      max={max}
      onChange={onSliderChange}
      value={value}
      {...props}
    />
  </div>;

}

